module.exports = __webpack_public_path__ + "static/media/pip_background.e0a70b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/pip_background.jpg
// module id = 341
// module chunks = 0